/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SendRequestToBeAnAgentLinkMutationVariables = {
    mobile: string;
};
export type SendRequestToBeAnAgentLinkMutationResponse = {
    readonly sendRequestToBeAnAgentLink: {
        readonly result: string;
    } | null;
};
export type SendRequestToBeAnAgentLinkMutation = {
    readonly response: SendRequestToBeAnAgentLinkMutationResponse;
    readonly variables: SendRequestToBeAnAgentLinkMutationVariables;
};



/*
mutation SendRequestToBeAnAgentLinkMutation(
  $mobile: String!
) {
  sendRequestToBeAnAgentLink(mobile: $mobile) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobile"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      }
    ],
    "concreteType": "SendRequestToBeAnAgentLink",
    "kind": "LinkedField",
    "name": "sendRequestToBeAnAgentLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendRequestToBeAnAgentLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendRequestToBeAnAgentLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c81c1f2d51e147787abbe1a46f879bd3",
    "id": null,
    "metadata": {},
    "name": "SendRequestToBeAnAgentLinkMutation",
    "operationKind": "mutation",
    "text": "mutation SendRequestToBeAnAgentLinkMutation(\n  $mobile: String!\n) {\n  sendRequestToBeAnAgentLink(mobile: $mobile) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = 'fa5c4ec5d9e2e82f7a0a0620da92f38a';
export default node;
